import { BulkPostLastGoldPrice } from "../../../api-layer/last-gold-price-api/BulkPostLastGoldPrice";
import { BulkPostParentGoldPrice } from "../../../api-layer/parent-gold-price-api/BulkPostParentGoldPrice";

export async function bulkPostGoldPricesV2({ requests, scope, set }) {
    console.log('scope is: ', scope)
    if(scope === "parent_quantity_definition"){
        try {
            const res = await BulkPostParentGoldPrice(requests);
            const results = res.data; 
            return results;
        } catch (err) {
            throw err;
        }
    } else {
        try {
            const res = await BulkPostLastGoldPrice(requests);
            const results = res.data; 
            return results;
        } catch (err) {
            throw err;
        }
    }

}